// extracted by mini-css-extract-plugin
module.exports = {"dotsWrapper":"ProgressBar-module__dotsWrapper","dot":"ProgressBar-module__dot","active":"ProgressBar-module__active","disabled":"ProgressBar-module__disabled"};